import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "wasp/client/auth";
import { routes } from "wasp/client/router";
import { Helmet } from "react-helmet-async";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import SocialProofBar from "./components/SocialProofBar";
import Pricing from "./components/Pricing";
import PricingTable from "./components/PricingTable";
import Testimonials from "./components/Testimonials";
import FreePlanHighlight from "./components/FreePlanHighlight";
import FeatureTabs from "./components/FeatureTabs";
import HowItWorks from "./components/HowItWorks";
import CtaFinal from "./components/CtaFinal";
import { getFaqs } from "./contentSections";
import useTranslation from "../client/hooks/useTranslation";
import { buildFaqPageLd, serializeJsonLd } from "../shared/seoJsonLd";

export default function LandingPage() {
  const { data: user, isLoading } = useAuth();
  const navigate = useNavigate();
  const t = useTranslation();

  const faqs = getFaqs(t);

  useEffect(() => {
    if (!isLoading && user) {
      navigate(routes.TradingDashboardRoute.to);
    }
  }, [user, isLoading, navigate]);

  // Afficher un loader pendant la vérification de l'authentification
  if (isLoading) {
    return null;
  }

  // Si l'utilisateur est connecté, ne rien afficher (redirection en cours)
  if (user) {
    return null;
  }

  return (
    <>
      <Helmet>
        <html lang="fr" />
        <title>Journal de trading prop firm : Edgely, analytics & payouts</title>
        <meta
          name="description"
          content="Le journal de trading conçu pour les prop traders : suivez Apex, TopStep, Lucid et Tradeify, respectez vos règles de drawdown et passez au funded. Gratuit."
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Journal de trading prop firm : Edgely, analytics & payouts" />
        <meta
          property="og:description"
          content="Le journal de trading conçu pour les prop traders : suivez Apex, TopStep, Lucid et Tradeify, respectez vos règles de drawdown et passez au funded. Gratuit."
        />
        <meta property="og:url" content="https://edgely.trade/" />
        <link rel="canonical" href="https://edgely.trade/" />
        <script type="application/ld+json">
          {serializeJsonLd(
            buildFaqPageLd(faqs.map((f) => ({ question: f.question, answer: f.answer }))) ?? {},
          )}
        </script>
      </Helmet>
      <div className="bg-background text-foreground">
        <main className="isolate">
          <Hero />
          <SocialProofBar />
          <FeatureTabs />
          <FreePlanHighlight />
          <HowItWorks />
          <Pricing />
          <PricingTable />
          <Testimonials />
          <FAQ faqs={faqs} />
          <CtaFinal />
        </main>
        <Footer />
      </div>
    </>
  );
}
